import type { Operand, SpecificationListItem } from 'api';

import { formatWeightFeature } from '../formatFeature/formatFeature';
import { formatInstructionWarning } from '../formatInstructionWarning/formatInstructionWarning';

export const formatWeightFeatureWithWarning = (
  operand: Operand,
  feature: ReturnType<typeof formatWeightFeature>,
  instructions?: SpecificationListItem[]
) => {
  const instructionWarning = formatInstructionWarning(operand, instructions);

  return {
    ...feature,
    highlight: instructionWarning?.highlight ?? false,
    warning: instructionWarning?.text,
  };
};
